import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { getGlobalConfig } from '@adornis/bh-matching-config/api/global-config.js';
import { GlobalConfig } from '@adornis/bh-matching-config/entities/global-config.js';
import type { TranslationDictionaryBuddy } from '@adornis/bh-matching-translation/translations.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('matching-comp-signup-closed')
export class MatchingCompSignupClosed extends ChemistryLitElement {
  @state() private readonly _config = new RXController(this, getGlobalConfig()(selectionSet(() => GlobalConfig, 2)));
  @state() protected readonly _translation = new TranslationController<TranslationDictionaryBuddy>(this);

  override render() {
    return html`
      <tr-card ${css({ margin: '0 auto' })}>
        <tr-flex padding="lg" space="lg" crossaxis-center>
          <tr-icon ${css({ color: this.colors.tone.warning, fontSize: this.spacing.xl })}> warning </tr-icon>
          <tr-tiptap
            .value=${this._config.value?.signupClosedNoteGerman ?? this._translation.translate('buddy', 'signupClosed')}
            disabled
            plain
            ${css({ maxWidth: this.sizes.maxReadableWidth, textAlign: 'center' })}
          >
          </tr-tiptap>
        </tr-flex>
      </tr-card>
    `;
  }
}
